import React, { FC, MouseEvent, PropsWithChildren } from 'react';
import { Button as Wrapper, Loading } from './styles';
import colors, { Colors } from 'theme/colors';
import { readableColor } from 'polished';
import { Size } from 'theme';
import Icon from 'components/atoms/Icon';

export interface IconButtonProps {
    onClick?: (event?: MouseEvent) => void;
    variant?: keyof Colors;
    disabled?: boolean;
    className?: string;
    loading?: boolean;
    rounded?: boolean;
    size?: keyof Size;
    icon: string;
    type?: 'button' | 'submit';
}

const IconButton: FC<PropsWithChildren<IconButtonProps>> = ({ loading, disabled, onClick, children, variant, icon, size, ...props }) => {
    // Button's methods.
    const handleOnClick = (event?: MouseEvent) => {
        if (onClick && (!loading || disabled)) {
            onClick(event);
        }
    };

    // Render.
    const color = colors[variant || 'black'];

    return (
        <Wrapper loading={loading} disabled={disabled || loading} variant={variant} onClick={handleOnClick} size={size} {...props}>
            {loading ? <Loading color={readableColor(color)} /> : icon && <Icon name={icon} color={readableColor(color)} size={1} />}
        </Wrapper>
    );
};

export default IconButton;
